import React from 'react'
import './Experience.css'
const Experience = () => {
  return (
    <div className="experience" id='Experience'>
        <div className="achievment">
            <div className="circle">😎</div>
            <span>Experience</span>
            <span>Fresher</span>
        </div>
        <div className="achievment">
            <div className="circle">10+</div>
            <span>Completed</span>
            <span>Projects</span>
        </div>
        <div className="achievment">
            <div className="circle">5+</div>
            <span>Real-Life</span>
            <span>Projects</span>
        </div>
    </div>
  )
}

export default Experience
